export const standardKeys = {
    all: ['standards'],
    catalog: ['standards', 'catalog'],
    detail: id => ['standards', 'detail', String(id)],
    versions: id => ['standards', 'versions', String(id)],
    version: id => ['standards', 'version', String(id)],
    rules: id => ['standards', 'rules', String(id)],
    sections: id => ['standards', 'rules', String(id), 'sections'],
    members: id => ['standards', 'rules', String(id), 'members'],
    resolved: id => ['standards', 'rules', String(id), 'resolved'],
};
